import { Helmet } from "react-helmet-async";

const SITE = "Specpixel Entertainment";
const BASE_URL = "https://specpixel.com";
const DEFAULT_IMG = `${BASE_URL}/assets/og-image.png`;

export default function Seo({ title, description, path = "/", keywords, image, jsonLd }) {
  const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Game Development & Outsourcing Studio Melbourne`;
  const url = `${BASE_URL}${path}`;
  const img = image ? `${BASE_URL}${image}` : DEFAULT_IMG;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
